export const COURSE_OPTIONS = [
  { value: '', label: 'All Courses' },
  { value: 'data-science', label: 'Data Science' },
  { value: 'web3', label: 'Web Development' },
];

export const TAG_OPTIONS = [
  { value: '', label: 'All Tags' },
  { value: 'pending', label: 'PENDING' },
  { value: 'progressComplete', label: 'PROGRESS_COMPLETE' },
  { value: 'abcat_attempted', label: 'AB_CAT_GIVEN' },
  { value: 'approved', label: 'APPROVED' },
  { value: 'pip', label: 'PIP' },
  { value: 'job_ready', label: 'JobReady' },
  { value: 'placed', label: 'Placed' },
];


export function getAllAlmaXStudentsFilters() {
  return [
    {
      name: 'email',
      label: 'Email',
      type: 'text',
      placeholder: 'Search by email',
      minWidth: 220,
    },
    // {
    //   name: 'cohort',
    //   label: 'AlmaX Cohort',
    //   type: 'text',
    //   placeholder: 'Search by cohort',
    //   minWidth: 180,
    // },
    {
      name: 'course',
      label: 'Course',
      type: 'select',
      options: COURSE_OPTIONS,
      minWidth: 160,
    },
    {
      name: 'tag',
      label: 'Tag',
      type: 'select',
      options: TAG_OPTIONS,
      minWidth: 140,
    },
  ];
}
